import { flow, Instance, types, getEnv } from "mobx-state-tree";

import { endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";
import { SubscriptionPlanUsage } from "./SubscriptionPlanUsage";
import { OrganizationVideoAnalysisCallsUsageResponse } from "../../api-models/response/organization/OrganizationVideoAnalysisCallsUsageResponse";
import { SubscriptionPlanUsageResponse } from "../../api-models/response/SubscriptionPlanUsageResponse";
import { SubscriptionVideoAnalysisCallsUsage } from "./SubscriptionVideoAnalysisCallsUsage";

const SubscriptionPlanUsageModel = types.model({
  subscriptionPlanUsage: types.optional(
    types.frozen<SubscriptionPlanUsage>(),
    new SubscriptionPlanUsage()
  ),
  subscriptionVideoAnalysisCallsUsage: types.optional(
    types.frozen<SubscriptionVideoAnalysisCallsUsage>(),
    new SubscriptionVideoAnalysisCallsUsage()
  ),
});

export const SubscriptionPlanUsageStorageModel = types
  .compose(SubscriptionPlanUsageModel, StorageModel)
  .named("SubscriptionPlanUsageStorrageModel")
  .actions((self) => {
    return {
      mapResponse(response: SubscriptionPlanUsageResponse) {
        self.subscriptionPlanUsage = new SubscriptionPlanUsage(response);
      },
      getOrganizationVideoAnalysisCallsUsage: flow(function* () {
        const endpoint = endpoints.get("organization_va_calls_usage");
        var response: OrganizationVideoAnalysisCallsUsageResponse = yield getEnv(self).api.get(endpoint);
        self.subscriptionVideoAnalysisCallsUsage = new SubscriptionVideoAnalysisCallsUsage(response);
        return response;
      }),
      getNumberOfExtraCallsAboveLimit(numberOfCallsNeeded: number) {
        if (
          self.subscriptionVideoAnalysisCallsUsage.successfulVideoAnalysisCallsCount >=
          self.subscriptionVideoAnalysisCallsUsage.totalVideoAnalysisCallsAvailable
        ) return numberOfCallsNeeded;
        return (
          self.subscriptionVideoAnalysisCallsUsage.successfulVideoAnalysisCallsCount +
          numberOfCallsNeeded -
          self.subscriptionVideoAnalysisCallsUsage.totalVideoAnalysisCallsAvailable
        );
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      return endpoints.get("subscription_plan_usage");
    },
    get isLoading() {
      return !self.subscriptionPlanUsage.totalFullRightsSeats;
    },
    get availableCallsLoading() {
      return !self.subscriptionVideoAnalysisCallsUsage.totalVideoAnalysisCallsAvailable;
    },
    get hasReachedVideoAnalysisLimitForFreeSubscription() {
      if (self.subscriptionVideoAnalysisCallsUsage.hasPaidSubscription) return false;

      return (
        self.subscriptionVideoAnalysisCallsUsage.successfulVideoAnalysisCallsCount >=
        self.subscriptionVideoAnalysisCallsUsage.totalVideoAnalysisCallsAvailable
      );
    },
  }));

export type SubscriptionPlanUsageStorage = Instance<typeof SubscriptionPlanUsageStorageModel>;
